import { render, staticRenderFns } from "./SharedGrids.vue?vue&type=template&id=7ff13fed&scoped=true&"
import script from "./SharedGrids.vue?vue&type=script&lang=js&"
export * from "./SharedGrids.vue?vue&type=script&lang=js&"
import style0 from "./SharedGrids.vue?vue&type=style&index=0&id=7ff13fed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff13fed",
  null
  
)

export default component.exports